import {Component, computed, inject} from '@angular/core';
import {Button} from 'primeng/button';
import {ROLES_CONFIG} from '../auth/models/user.models';
import {PermissionService} from '../auth/services/permission.service';
import {MailboxDialogService} from '../../features/mailbox-configurator/services/mailbox-dialog.service';
import {MailboxConfiguratorFacade} from '../../features/mailbox-configurator/mailbox-configurator.facade';

@Component({
	selector: 'app-mailbox-onboarding',
	standalone: true,
	template: `
		<div class="flex h-full w-full align-items-center justify-content-center">
			<div class="flex flex-column gap-3 px-8 py-6 text-center border-100 border-solid surface-50 border-round-2xl">
				<h2 class="m-0">Nessuna mailbox configurata</h2>

				@if (canConfigurateMailbox()) {
					<p class="m-0 text-color-secondary">
						Per iniziare, configura una mailbox.
					</p>
					<p-button label="Configura Mailbox"
							  icon="pi pi-cog"
							  severity="primary"
							  variant="outlined"
							  (onClick)="open()"/>
				} @else {
					<p class="m-0 text-color-secondary">
						Contatta un amministratore per completare la configurazione.
					</p>
				}
			</div>
		</div>
	`,
	imports: [
		Button
	],
	styles: ''
})
export class MailboxOnboardingComponent {
	private permission = inject(PermissionService)
	private facade = inject(MailboxConfiguratorFacade)
	protected mailboxConfigDialog = inject(MailboxDialogService)

	canConfigurateMailbox = computed(() =>
		this.permission.canAccess(ROLES_CONFIG)
	);

	open() {
		this.facade.startCreateMailbox();
		this.mailboxConfigDialog.openMailboxDialog(true);
	}
}
